// İSG uzmanı portalı — Taşeron/Yüklenici (Contractors) erişim kapısı (route guard UX).
//
// Asıl yetki backend'dedir (`[ModuleAction("contractors", …)]`); bu kapı yalnız UX'tir:
// erişim sondasının (useContractorsAccess) sonucuna göre Taşeron alt-ağacını (Outlet:
// liste + detay), 403 sayfasını veya "kullanılamıyor" durumunu gösterir. Ayarlar/
// Ziyaretçi kapılarıyla aynı desen; iş modülü olarak AYRIDIR.

import { Button, Card, CardContent, Spinner } from '@isgportal/shared';
import { HardHat, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { useContractorsAccess } from '../../lib/contractorsAccess';

export function ContractorsGate() {
  const { t } = useTranslation();
  const access = useContractorsAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner label={t('contractors.gate.loadingLabel')} />
      </div>
    );
  }

  if (access.status === 'forbidden') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <HardHat className="h-10 w-10 text-danger" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('contractors.forbidden.title')}</h1>
              <p className="text-sm text-muted">{t('contractors.forbidden.body')}</p>
            </div>
            <Button asChild variant="secondary">
              <Link to="/">{t('contractors.forbidden.back')}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (access.status === 'unavailable') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <TriangleAlert className="h-10 w-10 text-warning-foreground" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">
                {t('contractors.unavailable.title')}
              </h1>
              <p className="text-sm text-muted">{t('contractors.unavailable.body')}</p>
            </div>
            <Button onClick={access.refetch}>{t('contractors.unavailable.retry')}</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <Outlet />;
}
